import React from 'react'

import { Route, Switch, Redirect } from 'react-router-dom'

import { Welcome, SearchResult, Article, NotFound } from './pages'

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Welcome />
      </Route>
      <Route exact path="/category/:category?/:topic?/:article">
        <Article />
      </Route>
      <Route exact path="/search-result">
        <SearchResult />
      </Route>
      <Route path="/404" component={NotFound} />
      <Redirect from="*" to="/404" />
    </Switch>
  )
}

export default Routes
